// Marketing · Encuestas (montado en /marketing/encuestas/*): lista, detalle y editor.
import type { JSX } from "react";
import { Route, Routes } from "react-router-dom";
import { SurveyList } from "./surveys/SurveyList.tsx";
import { SurveyDetail } from "./surveys/SurveyDetail.tsx";
import { SurveyEditor } from "./surveys/SurveyEditor.tsx";

export function MktSurveys(): JSX.Element {
  return (
    <Routes>
      <Route index element={<SurveyList />} />
      <Route path=":id" element={<SurveyDetail />} />
      <Route path=":id/editar" element={<SurveyEditor />} />
    </Routes>
  );
}
